import {COINS_COLOR} from '../styles/constants';

/**
 * Потраченные монеты над ячейкой: всплывающее «−N» с иконкой монет — число
 * выпрыгивает, поднимается и гаснет так же, как «−N» удара ближнего боя (см.
 * configs/meleeAnimation, number). Показывается:
 *  - при найме отряда и при докупке его размера — над отрядом (см.
 *    scenes/playUnitRecruitmentEffects);
 *  - при постройке строения — над его ячейкой, в момент приземления жетона;
 *    при постановке строения в план — так же, но видит его только сам
 *    планирующий (см. scenes/playBuildingPlacementEffects).
 * Настоящие траты видят все участники матча.
 *
 * Рисует HexGridRenderer.showCoinsSpentNumber, расчет — в
 * utils/effects/buildCoinsSpentNumber, а когда число не показывается вовсе
 * (перемотка записи, скрытая вкладка) — в scenes/playCoinsSpentAnimation.
 */
export const COINS_SPENT_NUMBER = {
  // Откуда всплывает (доля размера ячейки над центром отряда) и на сколько
  startLiftFactor: 0.42,
  riseFactor: 0.85,
  // Чуть дольше числа урона: над ним нет удара, который объясняет число сам, —
  // его надо успеть прочесть вместе с иконкой
  durationMs: 1100,
  // Короткое «выпрыгивание» в начале: с этого масштаба до обычного
  popFromScale: 0.5,
  popMs: 130,
  // С этой доли пути число начинает гаснуть
  fadeFromProgress: 0.55,
  fontSizeFactor: 0.5,
  // Цвет монет в темном контуре: читается и на снежных подложках, и на
  // песчаных, где желтое без контура сливается с фоном. Контур у числа и у
  // иконки один — и цветом (strokeColor и strokeColor0x — одно значение в двух
  // записях: текст берет строку, текстура обводки — число), и толщиной
  color: COINS_COLOR,
  strokeColor: '#2b1a00',
  strokeColor0x: 0x2b1a00,
  // Толщина контура текста — доля размера шрифта. Контур ложится на край
  // цифр: наружу выходит половина
  strokeWidthShare: 0.2,
  icon: {
    // Ключ текстуры и размер картинки должны совпадать с загрузкой в
    // GameScene.preload() (/img/icons/coins.png)
    textureKey: 'coins_icon',
    textureSize: 512,
    // Высота иконки и зазор между числом и иконкой — доли размера ячейки
    sizeFactor: 0.4,
    gapFactor: 0.07,
    // Иконка стоит чуть ниже середины строки: цифры без нижних выносных, и по
    // общей середине она висела бы выше них
    shiftYFactor: 0.02,
    // Обводка иконки считается кодом по ее силуэту (см.
    // generateOutlineTexture) — по копии, уменьшенной до этой доли: на поле
    // иконка в десятки раз мельче своей картинки, и расчет по полной был бы
    // в шестнадцать раз дольше без видимой разницы
    outlineTextureKey: 'coins_icon_spent_outline',
    outlineSourceScale: 0.25,
  },
  // Число уместно, только пока трата свежа. У найма и у постройки оно
  // всплывает на приземлении жетона, а полет двойника идет по кадрам: в
  // скрытой вкладке кадры стоят, и жетон «садится» уже по возвращении — через
  // минуты после траты. Приземлился позже этого срока — числа нет (сам полет
  // длится доли секунды, см. BUILDING_DROP.durationMs)
  maxLandingDelayMs: 2000,
  // Несколько трат над одним отрядом подряд (докупка размера с нескольких
  // кварталов): прежние числа уступают место новому — поднимаются так, чтобы
  // между строками оставался этот шаг (доля размера ячейки), за pushMs
  stack: {
    lineStepFactor: 0.56,
    pushMs: 140,
  },
};
